// extracted by mini-css-extract-plugin
export default {"container":"calculatorSection_container__k-zYi","left_container":"calculatorSection_left_container__hQjha","right_container":"calculatorSection_right_container__XvddD"};